// extracted by mini-css-extract-plugin
export var root = "figure-module--root--1FgYF";
export var caption = "figure-module--caption--2c9T_ typography-module--small--2jpCI";